import { render } from "./SelfLeaveEdit.vue?vue&type=template&id=1122dc75"
import script from "./SelfLeaveEdit.vue?vue&type=script&lang=js"
export * from "./SelfLeaveEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__